import alertClose from './alertClose'

export const alertCloseService = alertClose
